import Swal from "sweetalert2";
import "@sweetalert2/theme-bootstrap-4/bootstrap-4.css"
const SwalAlert = function (confirmText) {

    const params = {
        icon: "",
        title: "",
        confirmButtonText: confirmText,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        target: "body",
    }

    function warning(title, text) {
        params.icon = "warning";
        params.title = title;
        params.text = text;
        return Swal.fire(params);
    }

    function info(title, text) {
        params.icon = "info";
        params.title = title;
        params.text = text;
        return Swal.fire(params);
    }

    function error(title, text) {
        params.icon = "error";
        params.title = title;
        params.text = text;
        return Swal.fire(params);
    }

    function success(title, text) {
        params.icon = "success";
        params.title = title;
        params.text = text;
        return Swal.fire(params);
    }

    return {
        params,
        warning,
        info,
        error,
        success
    };

}

export default SwalAlert